import { getNestedValue } from "../../../../../utils/function";

const TableDate = (props) => {
  let displayedDate = "-";

  const accessor = props.column.id;
  const time = getNestedValue(props.row.original, accessor, "-");
  const timeStr = time.$date || time;

  try {
    const splittedDate = timeStr.split("T");
    const ymd = splittedDate[0] || "-";
    const hms = splittedDate[1].split(".")[0] || "-";
    displayedDate = `${ymd} (${hms})`;
  } catch (e) {}

  return <span>{displayedDate}</span>;
};

export default TableDate;
